<template>
    <div>
        <h2 class="font-weight-semibold font-22 mb-2">
            Bienvenue à <span>Stark</span>
        </h2>

        <b-tabs nav-wrapper-class="nav-border nav nav-pills" v-model="tabIndex">
            <b-tab
                    :title-link-class="[
          'font-weight-semibold',
          'border-top-0',
          'border-right-0',
          'border-left-0'
        ]"
                    lazy
                    title="Se connecter"
            >
                <login-tab/>
            </b-tab>
            <b-tab
                    :title-link-class="[
          'font-weight-semibold',
          'border-top-0',
          'border-right-0',
          'border-left-0'
        ]"
                    lazy
                    title="S'inscrire"
            >
                <register-tab @goToTab="goToTab"/>
            </b-tab>
            <modal-success
                    id="email-sent"
                    title="Un e-mail vous a été envoyé."
            />
        </b-tabs>
    </div>
</template>

<script>
    import LoginTab from './loginTab';
    import RegisterTab from './registerTab';
    import ModalSuccess from '@/components/common/modal-success';

    export default {
        name: 'index',
        components: {RegisterTab, LoginTab, ModalSuccess},
        data() {
            return {
                tabIndex: 0
            };
        },
        methods: {
            goToTab() {
                this.tabIndex = 0;
            }
        },
        created() {
            localStorage.setItem("connected_domain", window.location.href.split('/')[5]);
            localStorage.setItem("connected_typePack", window.location.href.split('/')[6]);


        }
    };
</script>

<style scoped></style>
